import { BasicLayout } from './basic-layout'
import { BaseGrid } from '@components/base-grid'
import { BaseCell } from '@components/base-cell'
import Link from 'next/link'
import { colors } from '@styles/colors'
import { HeadingM, LabelM } from '@components/base-typography'
import { InfoBoxWithIcon } from '@components/info-box-with-icon'
import { BaseBlock } from '@components/base-block'
import { socialMedia } from '@components/footer/menus'
import { Icon } from '@components/icon'

interface NoticeLayoutProps {
  children?: React.ReactNode
  helmetTitle?: string
}

export const NoticeLayout = ({ children, helmetTitle }: NoticeLayoutProps) => {
  return (
    <BasicLayout helmetTitle={helmetTitle}>
      <BaseGrid spaceTop={[24, 48, 72]}>
        <BaseCell span={[4, 6, 8]} skip={[0, 1, 0]}>
          <HeadingM>공지사항</HeadingM>
          <BaseBlock marginTop="40px" marginBottom="40px">
            {children}
          </BaseBlock>
        </BaseCell>
        <BaseCell span={[4, 3, 3]} skip={[0, 1, 1]} spaceTop={[72, 72, 72]}>
          <InfoBoxWithIcon icon="AlertOn">
            <LabelM>온톨의 SNS에서 새로운 소식을 받아보세요.</LabelM>
            <BaseBlock flexbox columnGap="12px" marginTop="24px">
              {socialMedia.map(({ label, href, colorIcon }) => (
                <Link href={href} passHref key={label}>
                  <a target="_blank">
                    <Icon type={colorIcon} size={32} color={colors.gray400} />
                  </a>
                </Link>
              ))}
            </BaseBlock>
          </InfoBoxWithIcon>
        </BaseCell>
      </BaseGrid>
    </BasicLayout>
  )
}
